module.exports = __webpack_public_path__ + "img/sub_support_5.b5e46c49.png";